module.exports = __webpack_public_path__ + "img/icn_miniprogram.846944eb.png";